/* eslint-disable consistent-return */
import { useEffect } from 'react';

interface UseOnClickOutsideProps {
  ref: allAnyTypes;
  handler: allAnyTypes;
}

export const useOnClickOutside = ({
  ref,
  handler,
}: UseOnClickOutsideProps) => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export default useOnClickOutside;
